import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../../modules/helper";

const useCity = ({ id, provinceId }) => {
  const { data: city, refetch: refetchCityById } = useQuery({
    queryKey: ["cityById"],
    queryFn: () =>
      getAuthMethod("/address/v1/city/show/" + id).then(res => res.data),
    initialData: {},
    enabled: typeof id === "number",
    refetchOnWindowFocus: false,
  });

  const { data: cities } = useQuery({
    queryKey: ["cities"],
    queryFn: () =>
      getAuthMethod("/address/v1/city/show/" + provinceId).then(
        res => res.data.data
      ),
    initialData: [],
    enabled: typeof provinceId === "number",
    refetchOnWindowFocus: false,
  });

  return { city, cities };
};

export default useCity;
